import {createContext, useContext, useEffect, useReducer, useRef} from "react";
import {useCancelOrder, useConfirmGetGoods, useGetExpressDetail, useQryOrderListForApp,useUpdateVoucher} from "../../../../api/orderBase";
import {mediaMatch, queryParse} from "../../../../utils";
import cookies from "../../../../utils/cookies";
import {initialState, reducer, setLoading, setOrderList, setTotal, setTabActive, setQuery, setCommentVisible, setCommentGoodsDetail} from "./reducer";
import {useNavigateTo} from "../../../../hooks/useNavigateTo";
import Dialog from "../../../../publicComponent/Dialog";
import UploadImg from "../../../../publicComponent/uploadImg";
import useNotice from "../../../../hooks/useNotice";
import {useTranslation} from "react-i18next";
import {useBatchAddComment} from "../../../../api/shopItemComment";

const Context = createContext(initialState);

function OrderListController() {
  const { state, dispatch } = useOrderListContext();
  const { loading, getList } = useQryOrderListForApp();
  const { cancelOrder } = useCancelOrder();
  const { receivedHandle } = useConfirmGetGoods();
  const { expressDetailHandle } = useGetExpressDetail();
  const { t } = useTranslation();
  const notice = useNotice();
  const navigateTo = useNavigateTo();
  const isMdmax = mediaMatch.isMdmax;
  const listCache = useRef([]);
  const queryCache = useRef(state.query);
  const { updateVoucherHandle } = useUpdateVoucher();
  
  const getOrderList = async (query) => {
    
    let q = { ...queryCache.current, ...query };
    
    let { data } = await getList(q);
    
    dispatch(setQuery(q));
    queryCache.current = q;
    
    if (isMdmax) {
      // let list = q.page === 1 ? data.records : listCache.current.concat(data.records);
      let list = data.records;
      listCache.current = list;
      dispatch(setOrderList(list));
    } else {
      dispatch(setOrderList(data.records));
    }
    dispatch(setTotal(Number(data.total)));
  };
  
  const setTabsActive = (active) => {
    dispatch(setTabActive(active));
    getOrderList({
      ...queryCache.current,
      orderStatus: active || '',
      page: 1,
    });
  };
  
  const gotoOrderDetail = (goods) => {
    let query = queryParse({
      orderId: goods.orderId,
      orderNo: goods.orderNo,
      payType: goods.payType
    });
    navigateTo(`/orderDetail${query}`);
  };
  
  const gotoOrderQRCode = (goods) => {
    
    let query = queryParse({
      orderId: goods.orderId,
      orderNo: goods.orderNo
    });
    navigateTo(`/orderQRCode${query}`);
  };
  
  const cancelOrderHandle = (item) => {
    Dialog.confirm({
      content: t('确定要取消订单吗？'),
      onOk: async (onClose) => {
        let { data } = await cancelOrder({ orderId: item.orderId });
        if (data) {
          notice.success(t('操作成功'));
          getOrderList();
        }
        onClose();
      }
    });
  };
  
  const gotoOrderComment = (goods) => {
    let query = queryParse({
      orderId: goods.orderId,
      orderNo: goods.orderNo
    });
    navigateTo(`/orderComment${query}`);
  };
  
  const receivedOrder = (item) => {
    Dialog.confirm({
      content: t('确认收货吗？'),
      onOk: async (onClose) => {
        let { data } = await receivedHandle({ orderId: item.orderId });
        if (data) {
          notice.success(t('操作成功'));
          getOrderList();
        }
        onClose();
      }
    });
    
  };
  
  const getExpressDetail = async (q) => {
    
    let query = {
      expressCode: q.expressCode,
      expressNo: q.expressNo
    }
    console.log(query);
    return;
    const {data} = await expressDetailHandle(query);
    
    if (data){
      console.log(data);
    }
  };
  
  useEffect(() => {
    dispatch(setLoading(loading));
  }, [loading]);

  const showUploadVouchers = ({payType,orderId,voucher}) => {
    let img_result = "";
    const agentInfo = cookies.getAgentInfo();
    Dialog.qrcode({
      title: payType === "5" ? t("PayMe支付") : t("Fps支付"),
      qrcode: payType === "5" && `${agentInfo.paymeQrUrlView}`,
      content: payType === "6" && agentInfo.fpsTxt,
      showFooter: true,
      onOk: async (onClose) => {
        const q = {
          orderId,
          voucher: img_result,
        };
        const result = await updateVoucherHandle(q);
        console.log("result", result);
        if (result.code === 0) {
          notice.success(t("操作成功"));
          onClose();
          getOrderList();
        }
      },
      onCancel: (onClose) => {
        onClose();
      },
      renderElement: () => (
        <div className="flex justify-center mt-[10px]">
          <UploadImg
            label={t("上传凭证")}
            maxLength={1}
            multiple={false}
            onSuccess={(res) => {
              img_result = res[0];
            }}
            fileList={voucher && [voucher]}
          />
        </div>
      ),
    });
  }
  
  return {
    setTabsActive,
    cancelOrderHandle,
    getOrderList,
    gotoOrderDetail,
    gotoOrderQRCode,
    gotoOrderComment,
    receivedOrder,
    getExpressDetail,
    showUploadVouchers
  };
}

function useOrderListContext() {
  const { state, dispatch } = useContext(Context);
  
  return {
    state,
    dispatch,
  };
}

export {useOrderListContext, OrderListController};

export default function OrderListContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  
  return (
    <Context.Provider
      value={{ state, dispatch }}
      reducer={reducer}>
      {children}
    </Context.Provider>
  );
}
